import { SELECT_VEHICULO, RESET } from '../actions/Vehiculo';

const vehiculoReducer = (state = {}, action) => {
    switch (action.type) {
        case SELECT_VEHICULO:
            return action.vehiculo;
        case RESET: return {}
        default:
            return state;
    }
}

export default vehiculoReducer;
